<template>
  <div class="segment-table">
   
    <table v-if="data && !$asyncComputed.data.error">
      <thead>
        <th v-for="(h) in headers" :key="h" :class="{highlighted: currentCol === h}">{{h}}</th>
      </thead>
      <tbody>
        <tr v-for="(row,i) in tableData" :key="i">
          <td v-for="(cell,j) in row" :key="j"  :class="{highlighted: j==0 && currentSegment && currentSegment.id === row[0]}">
            <div class="cell-content">
              <div v-if="j===0" class="value">{{cell}}</div>
              <div
                v-else
                class="value"
              >{{formatValue(cell.mean)}} ± {{formatValue(cell.std)}}</div>

              <div v-if="j>0" class="mini-chart">
                <MiniEcg :data="cellDatas[i][j]" :showTooltip="true" :units="cellDatas[i][j].units"></MiniEcg>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <loading-overlay v-else-if="$asyncComputed.data.updating"></loading-overlay>
    <error-overlay v-else-if="$asyncComputed.data.error"></error-overlay>
  </div>
</template>

<script>
import widgetContent from '@/mixins/widgetContent'
import MiniEcg from '@/components/CaseDashboard/MiniEcg'
import { std, mean } from '@/utils/Math'
import {formatValue} from '@/utils'
import Api from '@/api'

export default {
  mixins: [widgetContent],
  components: {
    MiniEcg
  },
  props: ['currentTime','currentCol','currentSegment'],
  asyncComputed: {
    data () {
      return Api.getSegments(this.$store.state.paramsData)
    }
  },
  methods: {
    formatValue(d){
      return formatValue(d)
    }
  },
  computed: {
    cellDatas(){
      let res = this.data.map((s)=>{
        return s.segmentData.headers.map((h,col)=>{
          let points = s.segmentData.rows.map((r)=>({t:r[0],value:r[col]}))
          points.units = {x:s.segmentData.units[0],y:s.segmentData.units[col]}
          return points
        })
      })
      return res
    },
    tableData(){
      // NO INTERPOLA (creo que no tiene sentido, no?)
      // let nearestIdx = this.data[0].segmentData.rows.findIndex((d)=>d[0] > this.currentTime) - 1
      // return this.data.map((s)=>{
      //   return [s.segmentId, ...s.segmentData.rows[nearestIdx].slice(1)]
      // })
      return this.data.map((s)=>{
        let array = s.segmentData.rows
        let cellArrays = array[0].map((_, colIndex) => array.map(row => row[colIndex])).slice(1)
        let means = cellArrays.map((ca)=>mean(ca))
        let stds = cellArrays.map((ca)=>std(ca))
        let cellValues = means.map((m,i)=>{
          return {
            mean: m,
            std: stds[i]
          }
        })
        return [s.segmentId, ...cellValues]
      })
    },
    headers() {
      let raw = this.data[0].segmentData.headers.slice().map((h,col)=>{
        let unit = this.data[0].segmentData.units[col]
        if(unit) h = h+` (${unit})`
        return h
      })
      raw.splice(0,1,'segment')
      return raw
    }
  }

}
</script>

<style lang="stylus" scoped>
.segment-table
  background-color: #fff
  margin-bottom: 10px
  overflow: auto !important

  table
    border-spacing: 0
    text-align: center
    width: 100%

    thead
      th
        background-color: #fff
        m-font-size(12, 12)
        padding: 10px
        position: sticky
        text-align: left
        text-transform: capitalize
        top: 0
        z-index 100
        &.highlighted
          background-color: #ddd

    tbody
      tr
        &:nth-child(even)
          background-color: #f7f7f7

        td
          &.highlighted
            background-color: #ddd

          .cell-content
            align-items: center
            display: flex
            justify-content: center
            m-font-size(14, 14)
            padding: 4px 0

            .value
              flex: 0 0 80px
              margin: 0 10px
              white-space: nowrap

            .mini-chart
              flex: 1 1 200px
              height: 30px
              position relative
              // .mini-ecg
              //   position absolute
              //   width 100%
              //   height 100%
</style>